import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["categorySelect", "newCategoryInput", "checkbox", "counter", "card", "fields", "bulkCategorySelect", "submitButton"]

  connect() {
    this.updateCounter()
  }

  categoryChanged(event) {
    const select = event.target
    const itemId = select.dataset.itemId
    const newCategoryInput = this.newCategoryInputTargets.find(
      input => input.dataset.itemId === itemId
    )

    if (!newCategoryInput) return

    if (select.value === "__new__") {
      newCategoryInput.classList.remove("hidden")
      newCategoryInput.focus()
      select.value = ""
    } else {
      newCategoryInput.classList.add("hidden")
      newCategoryInput.value = ""
    }
  }

  selectAll() {
    this.checkboxTargets.forEach(cb => cb.checked = true)
    this.updateCounter()
  }

  deselectAll() {
    this.checkboxTargets.forEach(cb => cb.checked = false)
    this.updateCounter()
  }

  selectDuplicates() {
    this.checkboxTargets.forEach(cb => {
      cb.checked = cb.dataset.duplicate === "true"
    })
    this.updateCounter()
  }

  bulkCategoryChange() {
    const bulkSelect = this.bulkCategorySelectTarget
    const value = bulkSelect.value
    if (!value) return

    // チェック済みアイテムのカテゴリセレクトを一括変更
    this.checkboxTargets.forEach(cb => {
      if (!cb.checked) return
      const card = cb.closest("[data-ocr-confirm-target='card']")
      if (!card) return
      const categorySelect = card.querySelector("[data-ocr-confirm-target='categorySelect']")
      if (!categorySelect) return

      // 選択肢にvalueが存在する場合のみ変更
      const option = categorySelect.querySelector(`option[value="${value}"]`)
      if (option) {
        categorySelect.value = value
        // 新規カテゴリ入力欄を隠す
        const newInput = card.querySelector("[data-ocr-confirm-target='newCategoryInput']")
        if (newInput) {
          newInput.classList.add("hidden")
          newInput.value = ""
        }
      }
    })

    // セレクトをリセット
    bulkSelect.value = ""
  }

  confirmSubmit(event) {
    const checked = this.checkboxTargets.filter(cb => cb.checked).length
    if (checked === 0) {
      event.preventDefault()
      alert("メニューが1品も選択されていません。登録するメニューにチェックを入れてください。")
    }
  }

  updateCounter() {
    if (!this.hasCounterTarget) return
    const total = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter(cb => cb.checked).length
    this.counterTarget.textContent = `${checked}/${total}品を選択中`

    // チェック状態に応じてグレーマスクを付け外し
    this.checkboxTargets.forEach(cb => {
      const card = cb.closest("[data-ocr-confirm-target='card']")
      if (!card) return
      const fields = card.querySelector("[data-ocr-confirm-target='fields']")
      if (!fields) return

      if (cb.checked) {
        fields.classList.remove("ocr-item-disabled")
      } else {
        fields.classList.add("ocr-item-disabled")
      }
    })
  }
}
